export default __webpack_public_path__ + "static/media/MT_Calendar_Icon.7be698df.svg";